



























































































import {Vue, Component} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {addClass, removeClass} from '@/utils/classUtils';
import {getToday, addMonth, changeDateFormat} from '@/utils/dateUtils';
import {RadioRenderer} from '@/utils/commonUtils';
import {popupResize} from '@/utils/ncp';
import {i18nInObjectList} from '@/utils/i18n';
import TuiGrid from 'tui-grid';

import {GetCouponsRequest, PromotionSearchDateType, PromotionSearchKeywordType, PromotionCouponType, PromotionIssueType} from 'supporter';

@Component({
  components: {CompSelectBox, PeriodDateCalendar, RadioElement, ItemTable}
})
export default class GiveCoupon extends Vue {
  // query
  private memberNos: number[] = [];
  private mallNo: string = '';
  private target: string = '';

  // 검색어
  private searchType = 'ALL';
  private searchTypes = [
    {
      value: 'ALL',
      name: 'COMMON_ALL'
    },
    {
      value: 'COUPON_NAME',
      name: 'MEMBER_POPUP_SEARCH_TYPE_NAME'
    },
    {
      value: 'COUPON_NO',
      name: 'MEMBER_POPUP_SEARCH_TYPE_NO'
    }
  ];
  private keyword = '';

  // 기간
  private searchDateType: string = 'ISSUE_START_YMD';
  private searchDateTypes = [
    {
      value: 'ISSUE_START_YMD',
      name: 'MEMBER_POPUP_TERM_ISSUE_START_YMD'
    },
    {
      value: 'ISSUE_END_YMD',
      name: 'MEMBER_POPUP_TERM_ISSUE_END_YMD'
    },
    {
      value: 'REGISTER_YMD',
      name: 'MEMBER_POPUP_TERM_REGISTER_YMD'
    }
  ];
  private startYmd: string = addMonth(new Date(), -3);
  private endYmd: string = getToday();
  private changeDateType() {
    let calendar = this.$refs.dateCalendar as any;
    if (this.searchDateType === 'ISSUE_END_YMD') {
      calendar.editOption({endPeriod: true});
    } else {
      calendar.editOption({endPeriod: false});
    }
    this.startYmd = getToday();
    this.endYmd = getToday();
    if (calendar.calendarInfo.period) {
      calendar.clickPeriod(calendar.calendarInfo.period);
    }
  }

  // 쿠폰 발급 유형
  private issueType: string = '';
  private issueTypes = {
    name: 'issueType',
    data: [
      {
        id: 'issueType_ALL',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'issueType_DOWNLOAD',
        value: 'DOWNLOAD',
        dispaly: 'MEMBER_POPUP_ISSUE_TYPE_DOWNLOAD'
      },
      {
        id: 'issueType_CODE_DESIGNATE',
        value: 'CODE_DESIGNATE',
        dispaly: 'MEMBER_POPUP_ISSUE_TYPE_CODE_DESIGNATE'
      },
      {
        id: 'issueType_CODE_RANDOM',
        value: 'CODE_RANDOM',
        dispaly: 'MEMBER_POPUP_ISSUE_TYPE_CODE_RANDOM'
      },
      {
        id: 'issueType_INSERT',
        value: 'INSERT',
        dispaly: 'MEMBER_POPUP_ISSUE_TYPE_INSERT'
      }
    ]
  };

  // 혜택 구분
  private couponType: string = '';
  private couponTypes = {
    name: 'couponType',
    data: [
      {
        id: 'couponType_ALL',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'couponType_PRODUCT',
        value: 'PRODUCT',
        dispaly: 'MEMBER_POPUP_COUPON_TYPE_PRODUCT'
      },
      {
        id: 'couponType_CART',
        value: 'CART',
        dispaly: 'MEMBER_POPUP_COUPON_TYPE_CART'
      }
    ]
  };

  // 조회
  private async search(page: number = 1) {
    if (this.searchType !== 'ALL' && this.keyword === '') {
      alert(this.$t('COMMON_PLEASE_INPUT'));
      (this.$refs.keyword as any).focus();
      return;
    }
    let request: GetCouponsRequest = {
      params: {
        page,
        size: 20,
        mallNos: this.mallNo,
        searchDateType: this.searchDateType as PromotionSearchDateType,
        startYmd: this.startYmd,
        endYmd: this.endYmd,
        exceptIssueEndCoupon: true
      }
    };
    if (this.keyword.trim().length) {
      request.params.searchKeywordType = this.searchType as PromotionSearchKeywordType;
      request.params.keyword = this.keyword;
    }
    if (this.couponType !== '') {
      request.params.couponType = this.couponType as PromotionCouponType;
    }
    if (this.issueType !== '') {
      request.params.issueType = this.issueType as PromotionIssueType;
    }
    let memberGradeNo = this.$route.query.memberGradeNo;
    if (memberGradeNo) {
      request.params.memberGradeNo = Number(memberGradeNo);
    }
    const {data} = await this.$api.getCoupons(request);
    this.couponData = data.contents;
    this.totalCount = data.totalCount;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.totalCount = data.totalCount;
  }

  // 초기화
  private reset() {
    this.searchType = 'ALL';
    this.keyword = '';
    this.searchDateType = 'ISSUE_START_YMD';
    let calendar = this.$refs.dateCalendar as any;
    calendar.editOption({endPeriod: false});
    calendar.clickPeriod('3m');
    this.issueType = '';
    this.couponType = '';
  }

  // 조회결과
  private couponData = null as any;
  private totalCount: number = 0;
  private gridProps = {
    header: {
      height: 33
    },
    columns: [
      {
        header: 'MEMBER_POPUP_HEADER_COUPON_NO',
        name: 'no',
        align: 'center',
        minWidth: 120
      },
      {
        header: 'COMMON_MALL',
        name: 'mallName',
        width: 100,
        align: 'center'
      },
      {
        header: 'MEMBER_POPUP_HEADER_STATUS_TYPE',
        name: 'couponStatusType',
        width: 100,
        align: 'center',
        formatter: function (cell: any) {
          return window.$t(`MEMBER_POPUP_STATUS_TYPE_${cell.row.couponStatusType}`);
        }
      },
      {
        header: 'MEMBER_POPUP_HEADER_COUPON_NAME',
        name: 'couponName',
        align: 'center',
        minWidth: 140
      },
      {
        header: 'MEMBER_POPUP_HEADER_COUPON_TYPE',
        name: 'couponType',
        align: 'center',
        minWidth: 120,
        formatter: function (cell: any) {
          return window.$t(`MEMBER_POPUP_COUPON_TYPE_${cell.row.couponType}`);
        }
      },
      {
        header: 'MEMBER_POPUP_HEADER_ISSUE_TYPE',
        name: 'issueType',
        align: 'center',
        minWidth: 120,
        formatter: function (cell: any) {
          return window.$t(`MEMBER_POPUP_ISSUE_TYPE_${cell.row.issueType}`);
        }
      },
      {
        header: 'MEMBER_POPUP_HEADER_ISSUE_START_YMDT',
        name: 'issueStartYmdt',
        align: 'center',
        minWidth: 140,
        formatter: function (cell: any) {
          return changeDateFormat(cell.value, 'YYYY-MM-DD HH:mm:ss');
        }
      },
      {
        header: 'MEMBER_POPUP_HEADER_ISSUE_END_YMDT',
        name: 'issueEndYmdt',
        align: 'center',
        minWidth: 140,
        formatter: function (cell: any) {
          return changeDateFormat(cell.value, 'YYYY-MM-DD HH:mm:ss');
        }
      },
      {
        header: 'MEMBER_POPUP_HEADER_REGISTER_ADMIN',
        name: 'registerAdminName',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'COMMON_REGISTER_YMDT',
        name: 'registerYmdt',
        align: 'center',
        minWidth: 140,
        formatter: function (cell: any) {
          return changeDateFormat(cell.value, 'YYYY-MM-DD HH:mm:ss');
        }
      },
      {
        header: 'COMMON_UPDATE_ADMIN_NAME',
        name: 'updateAdminName',
        align: 'center',
        minWidth: 80,
        formatter: function (cell: any) {
          if (cell.value === null) {
            return '-';
          }

          return cell.value;
        }
      },
      {
        header: 'COMMON_UPDATE_YMDT',
        name: 'updateYmdt',
        align: 'center',
        minWidth: 140,
        formatter: function (cell: any) {
          if (cell.value) {
            return changeDateFormat(cell.value, 'YYYY-MM-DD HH:mm:ss');
          }
        }
      }
    ],
    options: {
      rowHeaders: [
        {
          name: 'radioBtn',
          type: 'radio',
          header: 'ADMIN_LIST_SELECT',
          renderer: RadioRenderer
        }
      ],
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      copyOptions: {
        useFormattedValue: true
      },
      rowHeight: 40,
      minRowHeight: 35,
      displayRowCount: 5,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        page: 1,
        totalCount: 0,
        perPage: 20
      }
    }
  };
  private tableOption = {
    autoHeight: true,
    haveRigthBtn: false,
    onLoadSearch: false
  };

  // 지급 대상회원
  private memberName: string = '';
  private reason: string = '';

  private async apply() {
    let checkedRows = (this.$refs.itemTable as any).gridFunction('getCheckedRows');
    let couponNo = checkedRows && checkedRows.length > 0 ? checkedRows[0].no : 0;
    if (couponNo === 0) {
      alert(this.$t('MEMBER_POPUP_ERROR_SELECT_COUPON'));
      return;
    }
    if (this.target === 'MEMBER') {
      this.memberApply(couponNo);
    } else if (this.target === 'MEMBER_GRADE') {
      this.gradeApply(checkedRows[0]);
    }
  }
  private async memberApply(couponNo: number) {
    if (!confirm(this.$t('MEMBER_POPUP_GIVE_COUPON_APPLY_CONFIRM') as string)) {
      return;
    }
    let request = {
      data: {
        reason: this.reason,
        memberNos: this.memberNos,
        couponNo: couponNo
      }
    };
    await this.$api.postCouponsIssues(request);
    let alertMsg = this.$t('MEMBER_POPUP_GIVE_COUPON_SUCCESS_MSG', [this.memberNos.length]);
    alert(alertMsg);
    if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
    }
    window.close();
  }
  private async gradeApply(row: any) {
    if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}(${JSON.stringify(row)});`);
    }
    window.close();
  }
  private cancel() {
    if (confirm(this.$t('MEMBER_POPUP_GIVE_COUPON_CLOSE_CONFIRM') as string)) {
      window.close();
    }
  }

  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.gridProps.options.rowHeaders[0].header = this.$t(this.gridProps.options.rowHeaders[0].header) as string;
  }

  private async mounted() {
    addClass(document.body, 'popup_large');
    if (this.$route.query) {
      // 지급 대상회원
      this.memberName = sessionStorage.getItem('memberName') as string;
      this.mallNo = this.$route.query.mallNo as string;
      this.target = this.$route.query.target as string;
      if (this.target === 'MEMBER') {
        this.memberNos = (this.$route.query.memberNumbers as string).split(',').map((item: string) => Number(item));
      }
    }
    let noData = this.$t('COMMON_NOT_DATA') as string;
    this.search();
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.$nextTick(() => {
      popupResize(undefined, 914);
    });
  }

  private beforeDestroy() {
    let noData = this.$t('COMMON_RESULT_NONE') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    removeClass(document.body, 'popup_large');
  }
}
